<template>
  <base-container
    title="Latest Events"
    view-link="/schedule/events"
    :with-gradient="events.length > 1"
    header-central
    no-padding
  >
    <base-scroll-list>
      <ol v-if="events.length > 0" role="list">
        <li v-for="(event, index) in events" :key="index" role="listitem">
          <card-list
            v-bind="event"
            @click="handleEventClick(event)"
            show-favourite
          ></card-list>
        </li>
      </ol>
      <p v-else role="event">There are no events</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
/**
 * # Dashboard events widget
 * ---
 * A widget to display events relevant to the users interest group
 *
 */
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

const CardList = () => import("@/components/Containers/BaseCardList");

export default {
  name: "EventsWidget",
  components: {
    BaseContainer,
    BaseScrollList,
    CardList,
  },

  data() {
    return {
      postLimit: 1,
      events: [],
    };
  },

  computed: {
    storeItems() {
      return this.$store.state.widgets.events.events;
    },
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
  },

  /**
   * When mounted we need to get the event items
   * TODO: Should these be put in state or just read from the user object
   */
  async mounted() {
    await this.$store.dispatch("widgets/events/setLimit", this.limit);
    await this.$store.dispatch("widgets/events/getLargestLimit");
    this.$store
      .dispatch("widgets/events/getEvents", { size: this.limit })
      .then((resp) => {
        this.events = resp.slice(0,this.limit);
      });
  },

  methods: {
    handleEventClick(event) {
      this.$router.push({
        name: "EventsSinglePage",
        params: { id: event.id },
      });
    },
  },

  watch: {
    storeItems: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.events = newVal.slice(0, this.limit);
      },
    },
    limit: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        this.postLimit = newValue;
        this.$store
          .dispatch("widgets/events/setLimit", this.postLimit)
          .then(() => {
            this.$store.dispatch("widgets/events/clearCache").then(() => {
              this.$store
                .dispatch("widgets/events/getEvents", { size: this.postLimit })
                .then((resp) => {
                  this.events = resp.slice(0,this.limit);
                });
            });
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
